export enum EItemType {
    C = 1,
    CW = 2,
    CH = 3,
    CD = 4,
    CWD = 5,
    CSI = 6,
    CHO = 7,
    CE = 8,
    CFE = 9,
    CFI = 10,
    CM = 11,
    CREF = 12,
    CS = 13,
    CSW = 14,
    CSH = 15,
    PD = 16,
    PB = 17,
    PBP = 18,
    PPC = 19,
    PPW = 20,
    PPH = 21,
    PPD = 22,
    PF = 23,
    PFC = 24,
    PFH = 25,
    PFW = 26,
    PFD = 27,
    PCF = 28,
    PCFC = 29,
    PCFH = 30,
    PCFW = 31,
    PCFD = 32,
    PCEF = 33,
    PP = 34,
    PPL = 35,
    PBA = 36,
    PTC = 37,
    PS = 38,
    PSC = 39,
    PSG = 40,
    PSH = 41,
    PSHG = 42,
    PSW = 43,
    PSSG = 44,
    PSD = 45,
    PSDG = 46,
    PV = 47,
    PCO = 48,
    PLP = 49,
    PTS = 50,
    PC = 51,
    PT = 52,
    PTB = 53,
    PW = 54,
    PSB = 55,
    PE = 56,
    EIC = 57,
    EEC = 58,
    EJ = 59,
    EOT = 60,
    HPTO = 61,
    HB = 62,
    HMD = 63,
    HIT = 64,
    HE = 65,
    HIE = 66,
    AL = 67,
    AI = 68,
    AF = 69,
    AE = 70,
    AO = 71,
    AOT = 72,
    SF = 73,
    SOT = 74,
    ED = 75,
    EWE = 76,
    EDE = 77,
    EHE = 78,
    EWR = 79,
    EDR = 80,
    EHR = 81,
    ES = 82,
    EF = 83,
    EDM = 84,
    AGL = 85,
    AGC = 86
}


export enum EItemTypeCategory
{
    BaseCabinet = 1,
    WallCabinet = 2,
    HighCabinet = 3
}